import React from "react";

export default function Loading() {
    return (
        <div className="loading-animate">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
        </div>
    );
}